module.exports = __webpack_public_path__ + "img/progress_bar_box.b952449b.png";